/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

type KahuPredefinedPromptChipProps = {
  prompt: string;
  sendUserPrompt: (prompt: string) => void;
};

export const KahuPredefinedPromptChip = ({
  prompt,
  sendUserPrompt,
}: KahuPredefinedPromptChipProps) => {
  return (
    <div
      onClick={() => sendUserPrompt(prompt)}
      className="group w-fit max-w-full cursor-pointer whitespace-normal break-words rounded-md border border-[#257C9D] bg-[#122C3A] px-3 py-1 text-[13px] font-normal text-[#B3E3EE] hover:border-[#7FCEE1] hover:bg-[#255165] hover:text-[#EFFAFC] active:border-[#2793B3] active:bg-[#224457] active:text-[##7FCEE1]"
    >
      {prompt}
    </div>
  );
};
